export function calculateDoughnutData(objects) {
  // 1) Transaction‐type buckets
  const tranCounts = { D: 0, K: 0, T: 0, G: 0, P: 0, U: 0, B: 0, F: 0, H: 0 };
  const tranAmounts = { D: 0, K: 0, T: 0, G: 0, P: 0, U: 0, B: 0, F: 0, H: 0 };

  // 2) Brand buckets
  const brandCounts = {
    Figaro: 0,
    "Angels Pizza": 0,
    "Tien Ma's": 0,
    "AP Express": 0,
    "Cafe Portofino": 0,
  };
  const brandAmounts = { ...brandCounts };

  // 3) Payment‐type buckets (dynamic)
  const paymentTypeCounts = {};
  const paymentTypeAmounts = {};

  objects
    .filter((obj) => obj.status === "C")
    .forEach((item) => {
      const txnTotal = parseFloat(item.total) || 0;

      // — Transaction Type
      if (tranCounts.hasOwnProperty(item.tran_type)) {
        tranCounts[item.tran_type]++;
        tranAmounts[item.tran_type] += txnTotal;
      }

      // — Brand (as before)
      if (item.id.includes("ANGELSPIZZA")) {
        brandCounts["Angels Pizza"]++;
        brandAmounts["Angels Pizza"] += txnTotal;
      }

      // — Payment Types: loop over all three “slots”
      ["", "2", "3"].forEach((suffix) => {
        const typeKey = `paymenttype${suffix}`;
        const totalKey = `paymenttype${suffix}total`;

        const typeRaw = item[typeKey];
        const amtRaw = item[totalKey];
        const type = typeRaw && typeRaw !== "-" ? typeRaw.trim() : null;
        const amt = parseFloat(amtRaw) || 0;

        if (type) {
          paymentTypeCounts[type] = (paymentTypeCounts[type] || 0) + 1;
          paymentTypeAmounts[type] = (paymentTypeAmounts[type] || 0) + amt;
        }
      });
    });

  // helper to convert counts → Highcharts-friendly [{ name, y, totalAmount }, …]
  const toChartData = (countsObj, amountsObj = {}) =>
    Object.entries(countsObj)
      .filter(([, cnt]) => cnt > 0)
      .map(([name, y]) => ({ name, y, totalAmount: amountsObj[name] || 0 }));

  return [
    // per-brand breakdown
    toChartData(brandCounts, brandAmounts),

    // per-transaction-type breakdown
    toChartData(
      {
        Dinein: tranCounts.D,
        "Drive-Thru": tranCounts.K,
        "Take-out": tranCounts.T,
        GrabFood: tranCounts.G,
        Pickup: tranCounts.P,
        Delivery: tranCounts.U,
        deltime: tranCounts.B,
        FoodPanda: tranCounts.F,
        Tablevibe: tranCounts.H,
      },
      {
        Dinein: tranAmounts.D,
        "Drive-Thru": tranAmounts.K,
        "Take-out": tranAmounts.T,
        GrabFood: tranAmounts.G,
        Pickup: tranAmounts.P,
        Delivery: tranAmounts.U,
        deltime: tranAmounts.B,
        FoodPanda: tranAmounts.F,
        Tablevibe: tranAmounts.H,
      }
    ),

    // per-payment-type breakdown (now including all “CASH”, “GC”, “MasterCard”, etc.)
    toChartData(paymentTypeCounts, paymentTypeAmounts),
  ];
}
